export default __webpack_public_path__ + "content/87544035a7560a4bbfea49599695c355.svg";